require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-crisis-intervention.json") })
        }
      }, "path---tags-crisis-intervention");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-crisis-intervention!./.cache/json/tags-crisis-intervention.json
// module id = 1001
// module chunks = 231608221292675